module.exports = __webpack_public_path__ + "static/media/normal-reproduction-high-resolution.8f42dcac.jpg";